import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Base64File } from "../models/base-64-file";

export function checkFilesValidationErrors(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: Base64File[] = control.value;
    if (!value) { return null; }

    let errorCount = 0;
    value.forEach(file => errorCount += (file.validationErrors || []).length);

    return errorCount > 0 ? { checkFiles: true } : null;
  }
}
